export const styles = {
    dialog: {
        "& .MuiDialog-paper": {
            width: "950px"
        }
    },
    dialogHeight: {
        "& .MuiDialog-paper": {
            height: "770px !important"
        }
    },
    dialogTitle: {
        paddingBottom: ({ spacing }) => spacing(3),
        border: ({ palette }) => `1px solid ${palette.greyscale[200]}`,
        borderTopLeftRadius: ({ spacing }) => spacing(1.25),
        borderTopRightRadius: ({ spacing }) => spacing(1.25),
        "& > div > div": {
            justifyContent: "flex-start"
        }
    },
    dialogContent: {
        padding: 0,
        borderLeft: ({ palette }) => `1px solid ${palette.greyscale[200]}`,
        borderRight: ({ palette }) => `1px solid ${palette.greyscale[200]}`
    },
    dialogAction: {
        border: ({ palette }) => `1px solid ${palette.greyscale[200]}`,
        borderBottomLeftRadius: ({ spacing }) => spacing(1.25),
        borderBottomRightRadius: ({ spacing }) => spacing(1.25)
    },
    childSectionTitleContainer: {
        borderBottom: 1,
        borderColor: ({ palette }) => palette.greyscale[200]
    },
    selectAllContainer: {
        minWidth: 0,
        overflow: "hidden",
        flexWrap: "nowrap"
    },
    selectAllPrefix: {
        whiteSpace: "nowrap",
        flexShrink: 0,
        width: "168px"
    },
    selectAllLabel: {
        color: "primary.700",
        fontFamily: "Inter",
        fontWeight: 500
    },
    selectAllSuffix: {
        whiteSpace: "nowrap",
        flexShrink: 0
    }
};
